"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 20.25c-4.55 0-8.25-3.7-8.25-8.25S7.45 3.75 12 3.75s8.25 3.7 8.25 8.25-3.7 8.25-8.25 8.25m0-15.476c-3.984 0-7.226 3.241-7.226 7.226S8.015 19.226 12 19.226s7.226-3.241 7.226-7.226S15.985 4.774 12 4.774"
}), 'RadioButtonEmpty');
//# sourceMappingURL=index.js.map